export interface ICustomSizes {
    customTireSize: string;
    customWheelSize: string;
}

export const CUSTOM_SIZES: (keyof ICustomSizes)[] = [
  "customTireSize",
  "customWheelSize",
];

export const CUSTOM_SIZES_WARNINGS = [
  "WARNING_TIRE_SIZE_FIT", "WARNING_WHEEL_SIZE_FIT",
];
